import React, { useState, useEffect } from 'react';
import { adminService } from '../../services/supabase';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import AdminResetPassword from './AdminResetPassword';

const AdminRouter = () => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    checkExistingSession();

    // Listen for path changes
    const handlePathChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePathChange);
    return () => window.removeEventListener('popstate', handlePathChange);
  }, []);

  const checkExistingSession = async () => {
    const sessionToken = localStorage.getItem('menuron_admin_session');

    if (sessionToken) {
      const { data, error } = await adminService.verifySession(sessionToken);

      if (data && !error) {
        setAdmin(data.admin);
      } else {
        // Invalid session, clear it
        localStorage.removeItem('menuron_admin_session');
      }
    }

    setLoading(false);
  };

  const handleAuthSuccess = (authData) => {
    setAdmin(authData.admin);
  };

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      const sessionToken = localStorage.getItem('menuron_admin_session');
      await adminService.logout(sessionToken);
      localStorage.removeItem('menuron_admin_session');
      setAdmin(null);
    }
  };

  // Check if we're on the reset password page
  const isResetPasswordPage = currentPath.includes('/reset-password') || currentPath.includes('/admin/reset-password');

  // Loading screen
  if (loading && !isResetPasswordPage) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '20px',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #dc2626',
            borderTop: '4px solid transparent',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite'
          }} />
          <h2 style={{ color: '#333', margin: '0' }}>Loading Admin Panel...</h2>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Show reset password page if on that route
  if (isResetPasswordPage) {
    return <AdminResetPassword />;
  }

  // Show login if not authenticated
  if (!admin) {
    return <AdminLogin onSuccess={handleAuthSuccess} />;
  }

  // Show dashboard if authenticated
  return <AdminDashboard admin={admin} onLogout={handleLogout} />;
};

export default AdminRouter;
